import styled from 'styled-components';

export const TimerContainer = styled.section`
  background: ${(props) => `linear-gradient(90deg, ${props.bgColor})`};
  padding: 24px 0;
  border-radius: 4px;
  margin: ${(props) => (props.showNameLeft ? '10px auto 8px' : '20px auto')};
  box-shadow: 1px 1px 4px #00000040;
  width: ${(props) => (props.timerOnPdp ? '100%' : '85%')};
  @media (max-width: 720px) {
    width: ${(props) => (props.timerOnPdp ? '100%' : '95%')};
    padding: 12px 0;
  }
`;

export const TimerHeading = styled.h4`
  font-weight: 500;
  color: rgb(0 0 0 / 78%);
  padding-bottom: ${(props) => (props.timerOnPdp ? '0' : '10px')};
  font-size: ${(props) =>
    props.timerOnPdp ? 'clamp(11px, 2vw, 16px)' : 'clamp(14px, 2vw, 16px)'};
`;

export const CountBoxDiv = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`;

export const FlexSection = styled.div`
  display: flex;
  align-items: center;
  width: 78%;
  justify-content: ${(props) => (props.showCta ? 'space-between' : 'center')};
  margin: auto;

  @media (max-width: 720px) {
    width: 96%;
  }
`;

export const ShopNowCTA = styled.button`
  border: none;
  outline: none;
  background: #ef4e5e;
  color: #fff !important;
  border-radius: 10vmax;
  font-family: 'Montserrat';
  text-align: center;
  font-size: clamp(12px, 2vw, 16px);
  font-weight: 500;
  display: block;
  flex-basis: 20%;
  height: clamp(34px, 3vw, 42px);
  line-height: clamp(34px, 3vw, 42px);
  position: relative;
  overflow: hidden;

  span.ripple {
    position: absolute;
    border-radius: 50%;
    transform: scale(0);
    animation: ripple 600ms linear;
    background-color: rgba(255, 255, 255, 0.7);
  }

  @keyframes ripple {
    to {
      transform: scale(4);
      opacity: 0;
    }
  }

  @media (max-width: 720px) {
    flex-basis: 32%;
    margin-right: 6px;
  }
`;

export const CountDownContainer = styled.div`
  display: flex;
  justify-content: center;
  p {
    font-size: 12px;
    font-weight: normal;

    color: #6e6e6e;
  }
  span {
    margin-left: 4px;
    margin-right: 4px;
    color: #6e6e6e;
    font-size: 12px;
  }
`;

export const CountDownBox = styled.div`
  text-align: center;
  width: ${(props) => (props.showCta ? '58%' : '100%')};
  display: ${(props) => (props.showCta || props.timerOnPdp ? 'flex' : 'block')};
  align-items: center;
  justify-content: space-between;

  @media (max-width: 720px) {
    width: ${(props) => (props.timerOnPdp ? '100%' : 'auto')};
    display: ${(props) => (props.timerOnPdp ? 'flex' : 'block')};
  }
`;

export const TimerSpan = styled.span`
  background-color: #fff;
  margin: 0 4px;
  display: inline-block;
  padding: 6px 0;
  font-weight: 600;
  font-size: clamp(14px, 2vw, 17px);
  color: rgb(0 0 0 / 76%);
  width: ${(props) =>
    props.timerOnPdp ? 'clamp(18px, 3vw, 30px)' : 'clamp(24px, 3vw, 30px)'};
  height: ${(props) =>
    props.timerOnPdp ? 'clamp(23px, 3vw, 35px)' : 'clamp(29px, 3vw, 35px)'};
  line-height: ${(props) =>
    props.timerOnPdp ? 'clamp(12px, 3vw, 23px)' : 'clamp(18px, 3vw, 23px)'};
`;

export const Dot = styled.span`
  display: ${(props) => (props.showNameLeft ? 'none' : ' inline')};
  margin: 6px 2px;
  color: #fff;
  font-weight: 500;
`;

export const HMS = styled.p`
  font-size: 10px;
  text-transform: uppercase;
  font-weight: 500;
  color: hsl(0deg, 0%, 0%, 78%);
  padding-top: 6px;
`;
